import script from "./TcNotification.vue.ts?vue&type=script&setup=true&lang=ts!=!../../../node_modules/rspack-vue-loader/dist/index.js??ruleSet[0].use[0]!./TcNotification.vue?vue&type=script&setup=true&lang=ts"
export * from "./TcNotification.vue.ts?vue&type=script&setup=true&lang=ts!=!../../../node_modules/rspack-vue-loader/dist/index.js??ruleSet[0].use[0]!./TcNotification.vue?vue&type=script&setup=true&lang=ts"

import "./TcNotification.vue.scss?vue&type=style&index=0&id=eb93a7d9&lang=scss!=!../../../node_modules/rspack-vue-loader/dist/index.js??ruleSet[0].use[0]!./TcNotification.vue?vue&type=style&index=0&id=eb93a7d9&lang=scss"

const __exports__ = script;

export default __exports__